import { render, staticRenderFns } from "./disponibilitaNre.vue?vue&type=template&id=fc1afb2a&scoped=true"
import script from "./disponibilitaNre.vue?vue&type=script&lang=js"
export * from "./disponibilitaNre.vue?vue&type=script&lang=js"
import style0 from "./disponibilitaNre.vue?vue&type=style&index=0&id=fc1afb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1afb2a",
  null
  
)

export default component.exports